
const getters = {
  getDebitById: (state, getters, rootState, rootGetters) => (id) => {
    console.log(state['moduleDebit'].debits)
    // return rootState.moduleDebit.debits.find(debit => debit.id === id)
  },
  // debits: state => state.debits,
}
export default getters